(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TeamManagementController', TeamManagementController);

    TeamManagementController.$inject = ['$state','Principal', 'Team', 'ParseLinks', 'paginationConstants', 'pagingParams', 'JhiLanguageService'];

    function TeamManagementController($state,Principal, Team, ParseLinks, paginationConstants, pagingParams, JhiLanguageService) {
        var vm = this;

        vm.clear = clear;
        vm.currentAccount = null;
        vm.languages = null;
        vm.links = null;
        vm.predicates = pagingParams.predicates;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.page = pagingParams.page;
        vm.setActive = setActive;
        vm.transition = transition;
        vm.totalItems = null;
        vm.users = [];
        vm.changePageSize = changePageSize;
        vm.currentState = "team-management";
        vm.charToSearch = pagingParams.search;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;
        vm.userStatus = pagingParams.status !== null ? pagingParams.status : '';
        vm.active = vm.userStatus === '' ? true : vm.userStatus === 'inactive' ? false : null;

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        vm.loadAll();


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        Principal.identity().then(function (account) {
            vm.currentAccount = account;
        });


        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        function loadAll() {
            Team.query(
                {
                    page: vm.page - 1,
                    size: vm.itemsPerPageChosen,
                    query: vm.charToSearch,
                    status: vm.active,
                    sort: sort()
                }, function (result, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                //vm.page = pagingParams.page;
                vm.users = result;
                    // transition();
            });
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        vm.showUserByStatus = function () {
            vm.page = 1;
            if(vm.userStatus == "all"){
                vm.active = null;
            }else if (vm.userStatus == "") {
                vm.active = true;
            } else if (vm.userStatus == "inactive") {
                vm.active = false;
            }
            loadAll();
        }


        function setActive(user, isActivated) {
            user.activated = isActivated;
            Team.update(user, function () {
                vm.loadAll();
                vm.clear();
            });

        }

        function clear() {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
            vm.editForm.$setPristine();
            vm.editForm.$setUntouched();

        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                status: vm.userStatus
            }, {notify: notify, location: "replace"});


        }

        vm.search = function () {
            pagingParams.page = 1;
            loadAll(false);
        };


        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        vm.newInvitation = function () {
            $state.go('invitation', null, {reload: true});
        }

        vm.invitationList = function () {
            $state.go('invitationList',null,{reload: true})
        }

    }
})();
